import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Dropdown } from "react-bootstrap";
import { OrdersChartComponent } from "../charts";

export default function OrdersCardComponent({ totalAmount, transactionCount }) {

    const { t, n } = useContext(TranslatorContext)

    const stats = [
        { 
            name: "total_amount", 
            value: totalAmount, 
            color: "blue", 
            icon: "attach_money" 
        },
        { 
            name: "transactions", 
            value: transactionCount, 
            color: "green", 
            icon: "receipt" 
        }
    ]

    return (
        <div className="mc-card">
            <div className="mc-card-header">
                <h4 className="mc-card-title">{t('orders_overview')}</h4>
                <Dropdown bsPrefix="mc-dropdown">
                    <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                        <i className='material-icons'>more_horiz</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end" className="mc-dropdown-paper">
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>history</i><span>{t('last_day')}</span></button>
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>history</i><span>{t('last_week')}</span></button>
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>history</i><span>{t('last_month')}</span></button>
                        <button type='button' className='mc-dropdown-menu'><i className='material-icons'>history</i><span>{t('last_year')}</span></button>
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <ul className="mc-order-card-list">
                {stats.map((stat, index) => (
                    <li key={ index } className="mc-order-card-item">
                        <i className={`material-icons ${ stat.color }`}>{ stat.icon }</i>
                        <p>{t(stat.name)}</p>
                        <h5>{n(stat.value)}</h5>
                    </li>
                ))}
            </ul>
        </div>
    )
}
